import React, { useState } from "react";
import { ConnectedRouter } from "connected-react-router";
import { Provider } from "react-redux";
import { Route, Switch, BrowserRouter as Router } from "react-router-dom";
import "react-notifications/lib/notifications.css";
import store, { history } from "./store";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./firebase/firebase";
import App from "./containers/App";
import { NotificationContainer } from "react-notifications";

const MainApp = () => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 10 * 60 * 1000,
            refetchInterval: false,
            refetchOnWindowFocus: false,
            refetchOnReconnect: true,
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Router basename="/portal">
            <Switch>
              <Route path="/" component={App} />
            </Switch>
          </Router>
        </ConnectedRouter>
        <NotificationContainer />
      </Provider>
    </QueryClientProvider>
  );
};

export default MainApp;
export { store };
